import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import './spinner.style.scss';

/**
 * Class representing spinner component.
 * @extends Component
 * */
@inject('commonStore')
@observer
class Spinner extends Component {

  static propTypes = {
    commonStore: PropTypes.shape({
      isSpinnerOn: PropTypes.bool.isRequired,
    }),
  };

  static defaultProps = {
    commonStore: {
      isSpinnerOn: false,
    },
  };

  render() {
    const { commonStore: { isSpinnerOn } } = this.props;

    if (isSpinnerOn) {
      return (
        <div className="app-spinner">
          <div className="spinner-background" />
          <FontAwesomeIcon icon={faCircleNotch} size="3x" spin />
        </div>
      );
    }

    return null;
  }

}

export default Spinner;



// WEBPACK FOOTER //
// ./src/common/components/spinner/spinner.component.js